// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPolicyImport } from 'src/types/d3ePolicy';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-import-exts-folders',
    templateUrl: './import-exts-folders.component.html',
    styleUrls: ['./import-exts-folders.component.scss'],
    standalone: false
})
export class ImportExtsFoldersComponent implements OnInit {

  isExts = false;
  selectedFile;
  fileData: IPolicyImport[] = [];
  importErrors = 0;

  fHeaderA: string;
  fAPA: string;
  fAPB: string;
  fAPC: string;
  fAPG: string;
  fAPJ: string;
  fAPK: string;
  fAPL: string;
  fHeaderB: string;
  fBPA: string;
  fBPB: string;
  fSubmit: string;
  fCancel: string;
  constructor(
      private translate: TranslateService,
      @Inject(MAT_DIALOG_DATA) public data: IImportDialogData, public dialogRef: MatDialogRef<ImportExtsFoldersComponent>) {
    this.translate.get(['IEF_HEADERA', 'IEF_A_P_A', 'IEF_A_P_B', 'IEF_A_P_C', 'IEF_A_P_G',
      'IEF_A_P_J', 'IEF_A_P_K', 'IEF_A_P_L', 'IEF_HEADER_B', 'IEF_B_P_A', 'IEF_B_P_B', 'SUBMIT',
      'CANCEL']).subscribe(vals => {
      this.fHeaderA = vals['IEF_HEADERA'];
      this.fAPA = vals['IEF_A_P_A'];
      this.fAPB = vals['IEF_A_P_B'];
      this.fAPC = vals['IEF_A_P_C'];
      this.fAPG = vals['IEF_A_P_G'];
      this.fAPJ = vals['IEF_A_P_J'];
      this.fAPK = vals['IEF_A_P_K'];
      this.fAPL = vals['IEF_A_P_L'];
      this.fHeaderB = vals['IEF_HEADER_B'];
      this.fBPA = vals['IEF_B_P_A'];
      this.fBPB = vals['IEF_B_P_B'];
      this.fSubmit = vals['SUBMIT'];
      this.fCancel = vals['CANCEL'];
    });
    this.isExts = data.openedByExts;
  }

  ngOnInit(): void {
  }

  fileBrowseHandler(files) {
    this.selectedFile = files[0];
    const reader = new FileReader();
    let fileContent = '';
    let lines : string[] = [];

    reader.onloadend = (e) => {
      this.importErrors = 0;
      fileContent = reader.result.toString();
      fileContent = fileContent.toLowerCase();
      fileContent = fileContent.trim();

      lines = fileContent.split("\n");

      let temp : IPolicyImport[] = [];
      let index = 0;
      lines.forEach(line => {
        let item : string[] = [];
        item = line.split(",");
        if (this.isExts && item[1] != null || (!this.isExts && item[1] != null && item[2] != null)) {
          let policyImport : IPolicyImport = {
            "value" : item[0].trim(),
            "setting" : item[1].trim()
          };
          if (!this.isExts) {
            policyImport.encryptedSetting = item[2].trim();
          }
          temp[index] = policyImport;
          index++;
        }
        else {
          this.importErrors++;
        }
      });

      this.fileData = temp;
   };

   reader.readAsText(this.selectedFile);
  }

  submit() {
    this.dialogRef.close([this.fileData, this.importErrors]);
  }

  cancel() {
    this.dialogRef.close();
  }
}

export interface IImportDialogData {
  openedByExts: boolean;
}
